export const USERS_NAMESPACE: string = 'users'
export const USER_EMAIL_FIELD_NAME: string = 'email'
export const USER_TYPE_FIELD_NAME: string = 'userType'
export const USER_CXS_SUBSCRIPTION_FIELD_NAME: string = 'cxsSubscription'
export const USER_CXI_LICENCE_FIELD_NAME: string = 'cxiLicence'
export const USE_EMAIL_AS_USERNAME_FIELD_NAME: string = 'useEmailAsUsername'
export const SEND_WELCOME_MAIL_FIELD_NAME: string = 'welcomeEmail'
export const SECURITY_GROUP_FILTER_NAME: string = 'securityGroup'

const getFieldName = (index: number, fieldName: string): string => `${USERS_NAMESPACE}[${index}].${fieldName}`

export const getUserEmailFieldName = (index: number): string => getFieldName(index, USER_EMAIL_FIELD_NAME)
export const getUserTypeFieldName = (index: number): string => getFieldName(index, USER_TYPE_FIELD_NAME)
export const getCxsSubscriptionFieldName = (index: number): string =>
    getFieldName(index, USER_CXS_SUBSCRIPTION_FIELD_NAME)
export const getCxiLicenceFieldName = (index: number): string => getFieldName(index, USER_CXI_LICENCE_FIELD_NAME)
export const getUseEmailAsUsernameFieldName = (index: number): string =>
    getFieldName(index, USE_EMAIL_AS_USERNAME_FIELD_NAME)
export const getWelcomeEmailFieldName = (index: number): string => getFieldName(index, SEND_WELCOME_MAIL_FIELD_NAME)
